import { BigqueryApi as Api, BigqueryTable } from "lib/Api";
import { action, observable } from "mobx";
import { call } from "lib/apiHelper";
import { defer } from "lib/defer";
import { notificationStore } from "lib/store";

export type InitialProps = {
  titleUuid: string;
  env: string;
};

let store: Store | undefined;

export function getStore() {
  if (!store) {
    throw new Error("Store not initialized");
  }
  return store;
}

export function createStore(props: InitialProps) {
  store = new Store(props);
}

class Store {
  app: AppStore;
  list: ListStore;
  ddl: DdlStore;

  constructor(props: InitialProps) {
    this.app = new AppStore(this, props);
    this.list = new ListStore(this);
    this.ddl = new DdlStore(this);
  }
}

class StoreBase {
  protected parent: Store;

  constructor(parent: Store) {
    this.parent = parent;
  }
}

class AppStore extends StoreBase {
  readonly titleUuid: string;
  readonly env: string;

  constructor(parent: Store, props: InitialProps) {
    super(parent);
    this.titleUuid = props.titleUuid;
    this.env = props.env;
  }
}

class ListStore extends StoreBase {
  @observable accessor isLoading = false;
  @observable accessor tables: BigqueryTable[] = [];

  @action async listTables() {
    this.isLoading = true;
    using _ = defer(() => (this.isLoading = false));
    const response = await call(
      Api.indexTitlesBigqueryTable(
        this.parent.app.titleUuid,
        this.parent.app.env,
      ),
    );
    if (response.code != 200) {
      return;
    }
    this.tables = response.body;
  }

  @action async deleteTable(table: string) {
    this.isLoading = true;
    using _ = defer(() => (this.isLoading = false));
    const response = await call(
      Api.destroyTitlesBigqueryTable(
        this.parent.app.titleUuid,
        this.parent.app.env,
        table,
      ),
    );
    if (response.code != 200) {
      return;
    }
    notificationStore.notifySuccess(response.body.message);
  }
}

class DdlStore extends StoreBase {
  @observable accessor isLoading = false;
  @observable accessor ddl = "";
  @observable accessor selectedTable = "";

  @action async getDdl(table: string) {
    this.selectedTable = table;
    this.isLoading = true;
    using _ = defer(() => (this.isLoading = false));
    const response = await call(
      Api.ddlTitlesBigqueryTable(
        this.parent.app.titleUuid,
        this.parent.app.env,
        table,
      ),
    );
    if (response.code != 200) {
      return;
    }
    this.ddl = response.body;
  }
}
